import _ from 'underscore';

/**
 * Default function to examine a location and determines if it is eligible as a radius target.
 * Logic taken from legacy file geoConverter.js.
 * @param {Object} location - Location to check.
 * @returns {Boolean} - True if it should be a radius target.
 */
export function getIsRadiusTarget(location) {
  if (location == null || location.Type == null) {
    return false;
  }

  // MT API location types
  // See: isRadiusTargetingAllowedForLocationType()
  if (_.contains(['Country', 'SubGeography', 'County', 'MetroArea'], location.Type)) {
    return false;
  }

  // Bing Maps API location types
  // See: isRadiusTargetingAllowedForBingMapsLocationTypes()
  if (_.contains(['Continent', 'CountryRegion'], location.Type)) {
    return false;
  }

  return true;
}
